import {
    getList as _getList,
    getAll as _getAll,
    add as _add,
    update as _update,
    getOneById as _getOneById,
    getListAsync as _getListAsync,
    deleteAll as _deleteAll,
} from "../../api";
import { smartDateTimeString12h } from "utils/dateUtils";

const BASE_URL = "/sign-in-sheets";
const DEFAULT_LIST_DATA = {
    filter: {},
    orderBy: "firstName",
    orderDirection: "asc",
    pageNumber: 0,
    pageSize: 5,
};

function normalizeSigninSheetData(data) {
    const { appointmentTime, stampCreationDatetime, assigneeUser, stampCreationUser, ...rest } = data;

    return {
        ...rest,
        assignee: assigneeUser || null,
        assigneeUser,
        stampCreationUser,
        assigneeName: assigneeUser ? assigneeUser.name : "",
        createdByName: stampCreationUser ? stampCreationUser.name : "",
        appointmentTime: appointmentTime ? new Date(appointmentTime) : null,
        appointmentTimeString: smartDateTimeString12h(appointmentTime ? new Date(appointmentTime) : null),
        stampCreationDatetime: stampCreationDatetime ? new Date(stampCreationDatetime) : null,
        stampCreationDatetimeString: smartDateTimeString12h(stampCreationDatetime ? new Date(stampCreationDatetime) : null),
    };
}

function normalizeData(data) {
    return data.map((d) => normalizeSigninSheetData(d));
}

export function getAll({ onSuccess, onError }) {
    _getAll({ url: BASE_URL, onSuccess, onError, normalizer: normalizeData });
}

export function getList({ onSuccess, onInfo, onError, data = DEFAULT_LIST_DATA }) {
    _getList({ url: BASE_URL, data, onSuccess, onInfo, onError, normalizer: normalizeData });
}

export async function getListAsync(data = DEFAULT_LIST_DATA) {
    return _getListAsync({ url: BASE_URL, data, normalizer: normalizeData });
}

export function getOneById({ id, onSuccess, onError }) {
    _getOneById({ url: `${BASE_URL}/${id}`, onSuccess, onError, normalizer: normalizeSigninSheetData });
}

export function add({ payload, onSuccess, onError }) {
    _add({ url: BASE_URL, data: payload, onSuccess, onError });
}

export function update({ payload, onSuccess, onError }) {
    _update({ url: `${BASE_URL}/${payload.id}`, data: payload, onSuccess, onError });
}

export function deleteAll({ ids, onSuccess, onError }) {
    _deleteAll({ url: BASE_URL, data: { ids }, onSuccess, onError });
}

export function getResources({ onSuccess, onError }) {
    onSuccess({
        users: [],
    });
}
